export default function StepSeparator(){
    return(
        <div className="hidden absolute top-0 left-0 w-3 inset-0 lg:block"
             aria-hidden="true">
            
        </div>
    )
}
